import { COUNTRIES, countryName } from '../constants/countries';

/**
 * The clinic's country — its JURISDICTION (PM-0082, root CLAUDE.md «Clinic
 * jurisdiction») — as a picker offers and a read-only field names it.
 *
 * The rows are the panel's country catalogue (the sign-in page's), named in the
 * reader's language. The service accepts every assigned ISO 3166-1 code, so a
 * clinic may hold one this catalogue lacks: it is then kept as an option under
 * its own code, never silently replaced by the first row.
 */

/** Every clinic that predates the field, and the server's own default. */
export const DEFAULT_COUNTRY = 'IR';

/** «ایران» — or the code itself for a country this build cannot name. */
export function countryLabel(code, locale) {
  const iso = code || DEFAULT_COUNTRY;
  const row = COUNTRIES.find((c) => c.iso2 === iso);
  return row ? countryName(row, locale) : iso;
}

/** Picker options, alphabetical in `locale`, always containing `current`. */
export function countryOptions(locale, current = DEFAULT_COUNTRY) {
  const rows = COUNTRIES
    .map((c) => ({ value: c.iso2, label: countryName(c, locale) }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
  const iso = current || DEFAULT_COUNTRY;
  return rows.some((r) => r.value === iso) ? rows : [{ value: iso, label: iso }, ...rows];
}
